import React from "react";
import { useNavigate } from "react-router-dom";

function CommonTableRow({ idx, beforePage, children, kind, loginId, loginName, onClick }) {
    const navigate = useNavigate();

    const handleRowClick = () => {
        switch (kind) {
            case 'manager':
                navigate(`/managerdetail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'cost':
                navigate(`/costdetail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'public':
                navigate(`/public_detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'staff':
                navigate(`/staff_detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'notice':
                navigate(`/notice_detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'event':
                navigate(`/event_detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'manager_notice':
                navigate(`/manager-notice-detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'manager_event':
                navigate(`/manager-event-detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'as':
                navigate(`/detail_as`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'coupon':
                navigate(`/detail_coupon`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            case 'notDetail':
                // Do nothing or add any specific behavior if needed
                break;
            case 'notice_list':
                navigate(`/noticelist_detail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
            default:
                navigate(`/listdetail`, { state: { beforePage, idx, id: loginId, loginName: loginName } });
                break;
        }

        // 추가된 onClick 핸들러 호출
        if (onClick) {
            onClick();  // 전달된 onClick 함수 실행
        }
    };

    return (
        <tr className="common-table-row" onClick={handleRowClick}>
            {children}
        </tr>
    );
}

export default CommonTableRow;
